import { useReducer } from 'react'
import ScoreContext from "./score-context";
const defaultScoreState = {
    randomId: 0,
    complianceRightAnswers: 0,
    memesRightAnswers: 0,
    email: ''
}

const scoreReducer = (state, action) => {
    if (action.type == 'COMPLIANCE') {
        let temp = state.complianceRightAnswers + 1;
        return {
            randomId: state.randomId,
            complianceRightAnswers: temp,
            memesRightAnswers: state.memesRightAnswers,
            email: state.email
        };
    }
    else if (action.type == 'MEMES') {
        let temp = state.memesRightAnswers + 1;
        return {
            randomId: state.randomId,
            complianceRightAnswers: state.complianceRightAnswers,
            memesRightAnswers: temp,
            email: state.email
        };
    }
    else if (action.type == 'SET_EMAIL') {
        let temp = action.payload;
        return {
            randomId: state.randomId,
            complianceRightAnswers: state.complianceRightAnswers,
            memesRightAnswers: state.memesRightAnswers,
            email: temp
        }
    }
    else if (action.type == 'GENERATE_RANDOM_ID') {
        let random = Math.round(Math.random() * 1000000000000)
        return {
            randomId: random,
            complianceRightAnswers: state.complianceRightAnswers,
            memesRightAnswers: state.memesRightAnswers,
            email: state.email
        }
    }
    return defaultScoreState;
}

const ScoreProvider = props => {

    const [scoreState, dispachScoreAction] = useReducer(scoreReducer, defaultScoreState)
    const increaseCompliance = () => {
        dispachScoreAction({ type: 'COMPLIANCE' })
    }
    const increaseMemes = () => {
        dispachScoreAction({ type: 'MEMES' })
    }
    const generateRandomId = () => {
        dispachScoreAction({ type: 'GENERATE_RANDOM_ID' })
    }
    const setEmail = (email) => {
        dispachScoreAction({ type: 'SET_EMAIL', payload: email })
    }
    const scoreContext = {
        randomId: scoreState.randomId,
        complianceRightAnswers: scoreState.complianceRightAnswers,
        memesRightAnswers: scoreState.memesRightAnswers,
        email: scoreState.email,
        increaseCompliance: increaseCompliance,
        increaseMemes: increaseMemes,
        setEmail: setEmail,
        generateRandomId, generateRandomId
    }
    return (<ScoreContext.Provider value={scoreContext}>
        {props.children}
    </ScoreContext.Provider>)
}

export default ScoreProvider;